Vue.component("MpAccordion", {

    props: {
        initial: {
            type: String,
            required: false,
            default: ''
        },
        imageRef: {
            type: String,
            required: false,
            default: ''
        }
    },

    data: function() {
        return {
            itemSelected: 0,
            nItems: 0,
        };
    },

    provide: function() {
        const accordionData = {};

        Object.defineProperty(accordionData, 'itemSelected', {
            enumerable: true,
            get: () => this.itemSelected,
        });

        return {
            accordionData
        };
    },

    computed: {},

    methods: {
        updateImage: function() {
            if (!this.imageRef) {
                return;
            }

            var imageStyle = document.querySelector('.'+this.imageRef).style;
            var accordionItem = document.getElementById(this.itemSelected);
            var img = (accordionItem && accordionItem.dataset) ? accordionItem.dataset.img : null;

            if (img) {
                imageStyle.backgroundImage = 'url("'+img+'")';
            }
        },

        init: function() {
           this.itemSelected = this.initial;
           this.$on(EVENT_ACCORDION.ITEM_CLICKED, this.onItemSelected);
           this.updateImage();
        },

        onItemSelected: function(data) {
            if (this.itemSelected === data.id) {
                return;
            }


            this.itemSelected = data.id;
            this.updateImage();
        }
    },

    mounted: function() {
        this.nItems = this.$refs.itemList.querySelectorAll('.accordion').length;

        this.init();
    },

    template: '\
    <div class="accordion" ref="itemList">\
        <slot name="items"></slot>\
    </div>',
});
